import css from "styled-jsx/css";

export const componentStyles = css.global`
  .notifications-tab-content {
  }
`;
